import { DragAndDropContext, Inserter, TinymcePortal } from "nystem-components";
import "./index.css";

const Index = () => (
  <DragAndDropContext>
    <TinymcePortal />
    <Inserter match="/*" source="/kulturnattSite/view" />
  </DragAndDropContext>
);

export default Index;
